import axios from "axios";
import { getToken } from "../../auth/authService";

const api = axios.create({
  baseURL: process.env.REACT_APP_BASE_URL,
  headers: {
    Authorization: `Bearer ${getToken()}`,
  },
});

export const fetchAllPayments = () =>
  api.get("/admin/payments/all");

export const fetchSuccessfulPayments = () =>
  api.get("/admin/payments/success");

export const fetchFailedPayments = () =>
  api.get("/admin/payments/failed");

export const fetchPaymentSummary = () =>
  api.get("/admin/payments/summary");

export const fetchPaymentsByUser = (userId) =>
  api.get(`/admin/payments/user/${userId}`);
